// Native quantities: this is the conversion used by ordinary multi-leg orders.
export const linkedNLegVolume = (volume: number, sourceContractSize: number, targetContractSize: number,
  sourceRatio: number, targetRatio: number) => sourceRatio > 0 && targetContractSize > 0
  ? volume * (sourceContractSize / targetContractSize) * (targetRatio / sourceRatio) : 0;
